export default __webpack_public_path__ + "static/sysi_logo-b2993a06d1b44e68c08594aa60288094.jpg";